import { render, staticRenderFns } from "./LoadAffirm.vue?vue&type=template&id=74702242&scoped=true"
import script from "./LoadAffirm.vue?vue&type=script&lang=js"
export * from "./LoadAffirm.vue?vue&type=script&lang=js"
import style0 from "./LoadAffirm.vue?vue&type=style&index=0&id=74702242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74702242",
  null
  
)

export default component.exports